export class environment {
   static baseUrl        : string | undefined   = 'https://mcsd.somee.com/';
   static serviceName    : string | undefined   = '[mcsd]';
};
